/**
 * Centralized query keys for TanStack Query
 * Using a factory pattern for consistent key generation
 */

export const queryKeys = {
  all: ['hobbes'] as const,

  apiKeys: {
    all: () => [...queryKeys.all, 'apiKeys'] as const,
    list: (organizationId: string) =>
      [...queryKeys.apiKeys.all(), organizationId, 'list'] as const,
  },

  webhooks: {
    all: () => [...queryKeys.all, 'webhooks'] as const,
    list: (organizationId: string) =>
      [...queryKeys.webhooks.all(), organizationId, 'list'] as const,
  },

  slack: {
    all: () => [...queryKeys.all, 'slack'] as const,
    config: (organizationId: string) =>
      [...queryKeys.slack.all(), organizationId, 'config'] as const,
    channels: (organizationId: string) =>
      [...queryKeys.slack.all(), organizationId, 'channels'] as const,
  },

  evaluator: {
    all: () => [...queryKeys.all, 'evaluator'] as const,
    datasets: (orgId: string) => [...queryKeys.evaluator.all(), orgId, 'datasets'] as const,
    dataset: (name: string, orgId: string) => [...queryKeys.evaluator.all(), orgId, 'dataset', name] as const,
    datasetItem: (datasetName: string, itemId: string, orgId: string) =>
      [...queryKeys.evaluator.all(), orgId, 'dataset', datasetName, 'item', itemId] as const,
  },

  customEvals: {
    all: () => [...queryKeys.all, 'customEvals'] as const,
    sets: (orgId: string) => [...queryKeys.customEvals.all(), orgId, 'sets'] as const,
  },
} as const;
